import "./KTextEditor.scss";
import KValidatableInput from "./KValidatableInput";
import { VCol } from "vuetify/lib";

export default {
	name: "KTextEditor",

	extends: KValidatableInput,

	props: {
		placeholder: {
			default: null,
			type: String
		},
		toolbar: {
			default: () => [
				"bold",
				"italic",
				"underline",
				"strikethrough",
				"olist",
				"ulist"
			],
			type: Array
		}
	},

	methods: {
		genValidatableField() {
			return <vue-pell-editor
				actions={this.toolbar}
				class="k-text-editor"
				placeholder={this.placeholder}
				styleWithCss={false}
				vModel={this.internalValue}
			></vue-pell-editor>;
		},

		genDefaultSlot() {
			return <VCol class="pa-0">
				{this.genLabel()}
				{this.genValidationProvider()}
			</VCol>;
		}
	}
};
